export default "__VITE_ASSET__DZNdYBhL__"